module.exports = __webpack_public_path__ + "static/media/xero_disconnect_btn.6a45cafc.svg";